"use client";

import { Badge } from "@packages/ui/components/badge";
import { cn } from "@packages/ui/lib/utils";

export type TaskStatus = "open" | "claimed" | "completed" | "cancelled";

const statusConfig: Record<TaskStatus, { label: string; className: string }> = {
	open: {
		label: "Open",
		className: "border-task-open/30 bg-task-open/10 text-task-open",
	},
	claimed: {
		label: "In Progress",
		className: "border-task-claimed/30 bg-task-claimed/10 text-task-claimed",
	},
	completed: {
		label: "Completed",
		className:
			"border-task-completed/30 bg-task-completed/10 text-task-completed",
	},
	cancelled: {
		label: "Cancelled",
		className:
			"border-task-cancelled/30 bg-task-cancelled/10 text-task-cancelled",
	},
};

export const statusColor: Record<TaskStatus, string> = {
	open: "text-[--task-open]",
	claimed: "text-[--task-claimed]",
	completed: "text-[--task-completed]",
	cancelled: "text-[--task-cancelled]",
};

export function TaskStatusBadge({
	status,
	className,
}: {
	status: TaskStatus;
	className?: string;
}) {
	const config = statusConfig[status];

	return (
		<Badge className={cn(config.className, className)}>{config.label}</Badge>
	);
}
